module.exports = __webpack_public_path__ + "static/media/Telegram.213d25a2.svg";